import { ArrowUpRight } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

export default function AboutUs() {
  return (
    <div className="bg-gray-100">
      {/* Hero Section */}
      <section className="relative w-full h-[500px] flex items-center justify-center text-center bg-cover bg-center bg-no-repeat" 
        style={{ backgroundImage: "url('/images/landing1.jpeg')" }}>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 max-w-4xl mx-auto text-white p-6">
          <h1 className="text-6xl xl:text-8xl font-bold">About Us</h1>
          <p className="text-lg md:text-xl mt-4">
            Your Trusted Partner in Tax & Accounting for Over 10 Years.
          </p>
        </div>
      </section>

      {/* About Us Content */}
      <div className="max-w-6xl mx-auto py-16 px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Side Text */}
          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-gray-900">Aggarwal Tax and Accounting Services</h2>
            <p className="text-lg text-gray-700 leading-relaxed text-justify">
              Aggarwal Tax and Accounting Services is a privately owned firm that has been 
              serving individuals and businesses since 2014. For the past 10 years, we have 
              provided reliable, personalized, and professional services for personal and 
              corporate tax returns.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed text-justify">
              Whether you’re an individual seeking tax filing assistance or a business 
              needing comprehensive accounting solutions, we are here to ensure your 
              financial success with accuracy and integrity.
            </p>
          </div>

          {/* Right Side Image */}
          <div className="relative">
            <img
              src="/images/pankaj.jpg"
              alt="Accounting Team"
              className="rounded-lg shadow-lg w-full"
            />
            <div className="absolute top-0 md:top-5 left-5 bg-white p-4 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold text-gray-900">10+ Years Experience</h3>
            </div>
            <div className="absolute bottom-5 right-5 bg-white p-4 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold text-gray-900">Trusted by 500+ Clients</h3>
            </div>
          </div>
        </div>
      </div>

      {/* Trust & Expertise Section */}
      <div className="bg-white py-16 px-6 md:px-12">
        <h2 className="text-3xl font-bold text-center text-gray-900">Why Choose Us?</h2>
        <div className="grid md:grid-cols-3 gap-8 mt-10 max-w-6xl mx-auto">
          {/* Card 1 */}
          <div className="bg-gray-100 p-6 rounded-lg shadow-md text-center">
            <h3 className="text-xl font-semibold text-gray-900">Expertise You Can Trust</h3>
            <p className="text-gray-700 mt-3">
              Our team stays updated on tax laws and financial regulations to provide accurate guidance.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-gray-100 p-6 rounded-lg shadow-md text-center">
            <h3 className="text-xl font-semibold text-gray-900">Personalized Services</h3>
            <p className="text-gray-700 mt-3">
              We tailor our solutions to fit your specific tax and accounting needs.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-gray-100 p-6 rounded-lg shadow-md text-center">
            <h3 className="text-xl font-semibold text-gray-900">Client-Centric Approach</h3>
            <p className="text-gray-700 mt-3">
              We focus on building long-term relationships with our clients through trust and transparency.
            </p>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="bg-slate-900 py-12 text-center text-white">
        <h2 className="text-3xl font-bold">Let Us Handle Your Taxes & Accounting</h2>
        <p className="text-lg mt-4">
          Contact us today and take the stress out of financial management.
        </p>
        <div className="flex justify-center mt-12">
           <Link to="/contactus">
        <button className="flex items-center gap-2 bg-amber-300 text-black p-3 px-6 text-lg font-semibold hover:bg-amber-600 transition">
    Schedule A Call
    <ArrowUpRight size={20} />
  </button></Link>
        </div>
       
      </div>
    </div>
  );
}
